module.exports = __webpack_public_path__ + "media/images/emblems/Biere-coat_of_arms-bbb4ef0201bd0e191803d70af9b56810.svg";